import {Briefcase, Smiley, Users} from '@phosphor-icons/react';
export const stats = [
	{
		icon: <Smiley size={56} color="rgba(255, 136, 0, 1)" />,
		number: '30+',
		text: 'Happy Clients',
		bgColor: 'rgba(255, 249, 238, 1)'
	},
	{
		icon: <Briefcase size={56} color="rgba(242, 73, 200, 1)" />,
		number: '2011',
		text: 'Established in',
		bgColor: 'rgba(254, 237, 250, 1)'
	},
	{
		icon: <Users size={56} color="rgba(15, 153, 24, 1)" />,
		number: '13',
		text: 'Years of Experience',
		bgColor: 'rgba(231, 245, 232, 1)'
	}
];
